export const generatePageRange = (start: number, end: number) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};

const computePaginationItems = ({
    pageCount,
    page,
    onChange,
}: {
    /**
     * Total number of pages
     */
    pageCount: number;
    /**
     * Currently active page
     */
    page: number;
    onChange(newPage: number): void;
}) => {
    const siblingsStart = Math.max(Math.min(page - 1, pageCount - 4), 3);
    const siblingsEnd = Math.min(Math.max(page + 1, 5), pageCount - 2);

    const siblingStartItem = 2 < pageCount - 1 ? [2] : [];
    const siblingsEndItem = pageCount - 1 > 1 ? [pageCount - 1] : [];
    const itemList = [
        1,
        ...(siblingsStart > 3 ? ['start-ellipsis'] : siblingStartItem),
        ...generatePageRange(siblingsStart, siblingsEnd),
        ...(siblingsEnd < pageCount - 2 ? ['end-ellipsis'] : siblingsEndItem),
        pageCount,
    ];

    return itemList.map(item => {
        return typeof item === 'number'
            ? {
                  onPageChange: (newPage: number) => {
                      onChange(newPage);
                  },
                  type: 'page',
                  page: item,
              }
            : {
                  type: item,
                  page: item,
              };
    });
};

export default computePaginationItems;
